// Libs
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Locales
import translationEN from '@app/locales/en/translation.json';
import translationVI from '@app/locales/vi/translation.json';
import translationJA from '@app/locales/ja/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  vi: {
    translation: translationVI,
  },
  ja: {
    translation: translationJA,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'vi',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
